module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/id_hokkaido-c4d5ae160d63d42168a32ef1985720ea.jpg";